import { Transform } from 'stream'
import util from 'util'

/**
 * Provides a mechanism to receive chunks of a data stream
 * Extends Stream.Transform and emits a 'data' event when a chunk is ready.
 *
 * @param stream The XHR stream
 * @param opts Options which may be overridden
 * @param {number} opts.chunkSize default:25
 * @constructor
 */
var Chunker = function (stream, opts) {
	opts = opts || {}
	Transform.call(this, {objectMode: true})
	this._calls = 0
	// 25 is a good number for the metrics report, because that is about all
	// that can fit on the screen
	this.chunkSize = opts.chunkSize || 25
	this.pausable = stream
	this.data = []
	// the other stream may keep pushing data even when "paused" so we have to
	// track this ourselves
	this.paused = false
	this.done = false
	this.dataEmitted = false
	this.endEmitted = false

	this.on('data', function() {
		this.dataEmitted = true
	}.bind(this))
}

util.inherits(Chunker, Transform)

Chunker.prototype._transform = function (data, encoding, done) {
	if (++this._calls % this.chunkSize === 0) {
		var p = this.paused
		this.pausable.pause()
		this.paused = true
		if (!p) {
			var d = this.data
			this.data = []
			this._calls = 0
			// emit data LAST, in case the event in turn triggers more data to be pushed through
			this.emit('data', d)
		}
	}
	this.data.push(data)
	done()
}

Chunker.prototype.end = function () {
	// Do not emit data on end. issue #6808 exhibits a problem where the screen
	// has all data because the end of the data stream from the server is reached
	// which causes data to be emitted. This bypasses the infinite scroll functionality
	// of the page which expects to control when data is emitted by calling next()

	this.done = true
	if(!this.dataEmitted || !this.endEmitted) {
		// If we're never emitted an end (still have data to emit) OR
		// If we've never emitted any data, call next to emit some. Code using this
		// component expects an initial batch of data to be emitted without having
		// to ask for it.
		this.next()
	}
}

Chunker.prototype.next = function() {
	if (this.done) {
		// send the next chunk, emit end if we've sent all data
		var d
		if (this.data.length >= this.chunkSize) {
			var d = this.data.slice(0, this.chunkSize)
			this.data = this.data.slice(this.chunkSize)
		}
		else {
			d = this.data
			this.data = []
		}
		// emit data LAST, in case the event in turn triggers another call to next
		if(d.length > 0) {
			this.emit('data', d)
		}
		if(this.data.length == 0 && !this.endEmitted) {
			this.endEmitted = true
			this.emit('end')
		}
	}
	else if (this.paused) {

		if (this.data.length <= this.chunkSize) {
			this.paused = false
			this.pausable.resume()
		}
		if (this.data.length >= this.chunkSize) {
			var d = this.data.slice(0, this.chunkSize)
			this.data = this.data.slice(this.chunkSize)
			// emit data LAST, in case the event in turn triggers another call to next
			this.emit('data', d)

		}
	}
}
export default Chunker

Chunker.__filename__ = 'components/chunker.js'
